import { Component } from '@angular/core';

@Component({
  selector: 'app-fr-tos-contents',
  templateUrl: './fr-tos-contents.component.html',
})
export class FrenchTOSContentsComponent {}
